export default __webpack_public_path__ + "static/media/strategyEng2.e6b1af7d.jpg";